import { getFormattedDate } from "../../utils/helper";
import styles from "./Footer.module.scss";

interface FooterProps {
  isFixed?: boolean;
}

const Footer = ({ isFixed = true }: FooterProps) => {
  return (
    <div className={`${styles.footer} ${isFixed ? styles.fixed : ""} `}>
      © {getFormattedDate(new Date(), "YYYY")} F. Hoffmann-La Roche Ltd
    </div>
  );
};

export default Footer;
